import { radarBlips } from "./radarData";

// Radar circular con barrido de luz continuo y pings de datos — panel
// derecho versión "La Brújula".
export function EcoRadar() {
  return (
    <div className="eco-radar">
      <span className="eco-radar__ring" style={{ inset: 0 }} />
      <span className="eco-radar__ring" style={{ inset: 60 }} />
      <span className="eco-radar__ring eco-radar__ring--dashed" style={{ inset: 130 }} />
      <span className="eco-radar__ring" style={{ inset: 200 }} />
      <span className="eco-radar__axis eco-radar__axis--h" />
      <span className="eco-radar__axis eco-radar__axis--v" />
      <span className="eco-radar__beam" />
      <span className="eco-radar__core" />

      {radarBlips.map((blip) => (
        <div key={blip.label} className="eco-radar__blip" style={{ left: blip.left, top: blip.top }}>
          <span className="eco-radar__blip-dot" style={{ animationDelay: `${blip.delay}s` }} />
          <span className="eco-radar__blip-text">
            <span className="eco-radar__blip-label">{blip.label}</span>
            <span className="eco-radar__blip-value">{blip.value}</span>
          </span>
        </div>
      ))}
    </div>
  );
}
